import { render, staticRenderFns } from "./score-statistics-table.vue?vue&type=template&id=5d916cdb&scoped=true"
import script from "./score-statistics-table.vue?vue&type=script&lang=js"
export * from "./score-statistics-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d916cdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d916cdb')) {
      api.createRecord('5d916cdb', component.options)
    } else {
      api.reload('5d916cdb', component.options)
    }
    module.hot.accept("./score-statistics-table.vue?vue&type=template&id=5d916cdb&scoped=true", function () {
      api.rerender('5d916cdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/user/manage/components/score-statistics-table.vue"
export default component.exports